var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.temBuscas
    ? _c(
        "div",
        _vm._b(
          { staticClass: "busca-web ia-block-card" },
          "div",
          _vm.MOLDURA_DO_THREAD,
          false
        ),
        [
          _c(
            "button",
            {
              staticClass:
                "ia-block-card__cabecalho ia-block-card__cabecalho--fita ia-block-card__cabecalho--clicavel",
              attrs: {
                type: "button",
                "aria-expanded": String(_vm.aberto),
                "aria-label": _vm.BUSCA_WEB.ARIA_LISTA,
                "data-test": "busca-web-cabecalho"
              },
              on: { click: _vm.alternar }
            },
            [
              _c("icon-svg", {
                staticClass: "ia-block-card__icone",
                attrs: {
                  name: "search-normal",
                  size: 14,
                  color: "var(--primary)"
                }
              }),
              _c("span", { staticClass: "ia-block-card__titulo" }, [
                _vm._v(_vm._s(_vm.BUSCA_WEB.TITULO))
              ]),
              _c("span", { staticClass: "ia-block-card__meta" }, [
                _vm._v(_vm._s(_vm.resumo))
              ]),
              _c("icon-svg", {
                staticClass: "ia-block-seta",
                class: _vm.classeSeta,
                attrs: {
                  name: "arrow-down-new-ux",
                  size: 14,
                  color: "var(--neutral-700)"
                }
              })
            ],
            1
          ),
          _vm._l(_vm.buscasDecoradas, function(busca) {
            return _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.aberto,
                    expression: "aberto"
                  }
                ],
                key: busca.chave,
                staticClass: "busca-web__item",
                attrs: { "data-test": "busca-web-item" }
              },
              [
                _c(
                  "div",
                  { staticClass: "busca-web__consulta ia-texto-auxiliar" },
                  [
                    busca.emAndamento
                      ? _c("span", { staticClass: "busca-web__prefixo" }, [
                          _vm._v(
                            " " + _vm._s(_vm.BUSCA_WEB.EM_ANDAMENTO) + ": "
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" " + _vm._s(busca.rotulo) + " ")
                  ]
                ),
                busca.frase
                  ? _c(
                      "p",
                      {
                        staticClass: "busca-web__frase ia-texto-auxiliar",
                        attrs: { role: "alert", "data-test": "busca-web-frase" }
                      },
                      [_vm._v(" " + _vm._s(busca.frase) + " ")]
                    )
                  : _vm._e(),
                busca.permitido
                  ? _c(
                      "p",
                      { staticClass: "busca-web__permitido ia-texto-auxiliar" },
                      [
                        _vm._v(
                          " " +
                            _vm._s(_vm.BUSCA_WEB.DOMINIOS_LIBERADOS) +
                            " " +
                            _vm._s(busca.permitido) +
                            " "
                        )
                      ]
                    )
                  : _vm._e(),
                busca.temFontes
                  ? _c(
                      "ul",
                      { staticClass: "busca-web__fontes" },
                      _vm._l(busca.fontes, function(fonte) {
                        return _c(
                          "li",
                          {
                            key: fonte.chave,
                            staticClass: "busca-web__fonte",
                            attrs: { "data-test": "busca-web-fonte" }
                          },
                          [
                            _c(
                              "a",
                              {
                                staticClass: "busca-web__fonte-link",
                                attrs: {
                                  href: fonte.url,
                                  target: "_blank",
                                  rel: "noopener noreferrer",
                                  "aria-label": _vm.BUSCA_WEB.ABRIR_FONTE,
                                  "data-test": "busca-web-fonte-link"
                                }
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "busca-web__fonte-titulo ia-texto-auxiliar"
                                  },
                                  [_vm._v(_vm._s(fonte.titulo))]
                                ),
                                _c("icon-svg", {
                                  attrs: {
                                    name: "go-out",
                                    size: 12,
                                    color: "var(--neutral-700)"
                                  }
                                })
                              ],
                              1
                            ),
                            _c(
                              "span",
                              {
                                staticClass:
                                  "busca-web__fonte-legenda ia-texto-auxiliar"
                              },
                              [_vm._v(_vm._s(fonte.legenda))]
                            ),
                            fonte.trecho
                              ? _c(
                                  "span",
                                  {
                                    staticClass:
                                      "busca-web__fonte-trecho ia-texto-auxiliar"
                                  },
                                  [_vm._v(" " + _vm._s(fonte.trecho) + " ")]
                                )
                              : _vm._e()
                          ]
                        )
                      }),
                      0
                    )
                  : _vm._e(),
                busca.podeAlternarFontes
                  ? _c(
                      "button",
                      {
                        staticClass: "busca-web__ver-mais ia-texto-selo",
                        attrs: {
                          type: "button",
                          "data-test": "busca-web-ver-mais"
                        },
                        on: {
                          click: function($event) {
                            return _vm.alternarFontes(busca.indice)
                          }
                        }
                      },
                      [_vm._v(" " + _vm._s(busca.rotuloVerMais) + " ")]
                    )
                  : _vm._e()
              ]
            )
          })
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }